import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["modal", "content"]

    connect() {
        console.log("DriverResponse controller connected")
    }

    show(event) {
        event.preventDefault()

        let responseData = { documents: [] }
        try {
            const response = event.currentTarget.dataset.response
            if (response && response.trim() !== '') {
                responseData = JSON.parse(response)
            }
        } catch (e) {
            console.error("Błąd parsowania JSON:", e.message)
            responseData = { documents: [] }
        }

        const html = this.formatResponseData(responseData)
        this.contentTarget.innerHTML = html

        this.modalTarget.classList.add('show')
        this.modalTarget.style.display = 'block'
        document.body.classList.add('modal-open')
    }

    hide(event) {
        event.preventDefault()
        this.modalTarget.classList.remove('show')
        this.modalTarget.style.display = 'none'
        document.body.classList.remove('modal-open')
    }

    formatResponseData(data) {
        if (!data || !data.documents || data.documents.length === 0) {
            return "<p>Brak danych odpowiedzi</p>"
        }

        return data.documents.map((doc, index) => {
            // Sprawdzamy, czy status różni się od "Wydany"
            const isInvalid = doc.status.value !== "Wydany"
            const statusClass = isInvalid ? "invalid-status" : ""

            return `
                <div class="mb-3">
                    <h5>Prawo jazdy #${index + 1}</h5>
                    <ul class="list-group ${statusClass}">
                        <li class="list-group-item"><strong>Typ dokumentu:</strong> ${doc.type.value} (${doc.type.code})</li>
                        <li class="list-group-item"><strong>Numer seryjny:</strong> ${doc.serial_number}</li>
                        <li class="list-group-item"><strong>Organ wydający:</strong> ${doc.issuing_authority.value} (${doc.issuing_authority.code})</li>
                        <li class="list-group-item"><strong>Status:</strong> ${doc.status.value} (${doc.status.code})</li>
                        <li class="list-group-item">
                            <strong>Kategorie:</strong>
                            <ul>
                                ${doc.categories.map(cat => `<li>${cat.category} (Ważność: ${cat.expiry_date || 'Brak'})</li>`).join('')}
                            </ul>
                        </li>
                    </ul>
                </div>
            `
        }).join('')
    }
}